import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Unregister any active service worker to prevent static assets caching issues
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  }).catch((err) => console.error("Failed to unregister Service Worker:", err));
}

// Reload on chunk/script load syntax errors to fetch the latest assets
window.addEventListener("error", (e) => {
  if (e.message && (e.message.includes("Unexpected token '<'") || e.message.includes("chunk"))) {
    console.warn("Script load failure detected. Reloading page to fetch latest version...");
    window.location.reload();
  }
}, true);
